import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { updateCertInfo } from '../actions'

class CertImage extends React.Component {
  static propTypes = {
    header: PropTypes.string,
    certInfo: PropTypes.object,
    image: PropTypes.object,
    updateInfo: PropTypes.func,
  }

  handleChange = () => {
    let newImage = this.imageInput.files[0]
    let newName = newImage.name
    let certInfo = {}
    let reader = new FileReader()
    reader.readAsDataURL(newImage)
    reader.onload = e => {
      certInfo.image = e.target.result
      certInfo.imageName = newName
      certInfo.imageLoaded = true
      certInfo.newUploadedImage = true
      this.props.updateInfo(certInfo)
    }
  }

  render() {
    return (
      <div className="image_info">
        <input
          type="file"
          id="image_input"
          accept=".png, .jpeg, .jpg"
          ref={input => {
            this.imageInput = input
          }}
          onChange={this.handleChange}
        />
        <p>{this.props.certInfo.imageName}</p>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    certInfo: state.certInfo,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateInfo: certInfo => {
      dispatch(updateCertInfo(certInfo))
    },
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CertImage)
)
